<template>
<div class="row">
	<div class="col-12">

		<div class="row" v-if="Object.keys(classesData).length">
			<div class="col-sm-6 col-lg-4 text-center" v-for="(item, index) in classesData.active_classes" :key="index">
				<button class="btn btn-yellow-o btn-sm rounded-pill d-inline-block w-100 mt-1">
					{{item.classe != '' && item.classe != 0 ? item.classe + '° ' : ''}}{{item.sezione}}
				</button>
			</div>
		</div>

		<div class="row">
			<div class="col-12 mt-4">
				<label class="bold" for="nome">VUOI INSERIRE UNA NUOVA CLASSE?</label>
			</div>
		</div>

		<form @submit.prevent.stop="addClass">
			<div class="row align-items-center">
				<div class="col-sm-9 form-group" v-if="schoolType == 'i'">
					<input type="text" name="sezione" id="sezione" class="form-control form-control-lg" placeholder="Scrivi il nome della classe" required autocomplete="aut_off_iuasdsvkz" maxlength="100" v-model="newClass.sezione">
				</div>
				<div class="col-sm-3 col-md-4 col-lg-3 form-group">
					<input type="submit" class="btn btn-blue-light btn-sm rounded-pill w-100" value="INVIA">
				</div>
			</div>
		</form>

		<div class="row" v-if="classesData.unavailable_classes && classesData.unavailable_classes.length">
			<div class="col-12">
				<p>Attenzione: le seguenti classi sono state rimosse in quanto sono già state iscritte da un altro insegnante.</p>
				<p>
					<span v-for="(unavailable, ind) in classesData.unavailable_classes" :key="ind">{{unavailable.classe}} {{unavailable.sezione}}</span>
				</p>
			</div>
		</div>

	</div>
</div>

</template>

<script>
import axios from 'axios'

export default {
	name: 'ClassesListComponent',
	props: ['idTeacher', 'schoolType'],

	data() {
		return {
			classesData: {},
			newClass: {
				classe: '',
				sezione: ''
			},
			ajaxObj: window.ajax_object,
		}
	},

	methods: {
		getClassesData() {
			let url = this.ajaxObj.ajax_url
			axios.get(url,
			{
				params: {
					_nounce_value: this.ajaxObj._nounce_value,
					action: 'nl_get_classes_list',
					idTeacher: this.idTeacher
				}
			})
			.then((response) => {
				this.classesData = response.data.classesData
				// console.log(response.data.classesData)
			})
			.catch((err) => {
				console.log(err)
			})
		},

		addClass() {
			let url = this.ajaxObj.ajax_url
			var formData = new FormData();
			formData.append('action', 'nl_add_new_school_class')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('classe', this.newClass.classe)
			formData.append('sezione', this.newClass.sezione)
			formData.append('schoolType', this.schoolType)

			axios.post(url, formData)
				.then((response) => {
					// console.log(response.data)
					if(response.data.error == '') {
						this.getClassesData()
						this.newClass.sezione = ''
						this.newClass.classe = this.schoolType == 'i' ? '0' : ''
					}
				}, (error) => {
					console.log(error);
				});
		}
	},

	mounted() {
		this.getClassesData()
		this.newClass.classe = this.schoolType == 'i' ? '0' : ''
	}
}
</script>
